module.exports = __webpack_public_path__ + "static/media/Phone_Next_Button.979b5e54.svg";